import Icon from 'images/Icon/Desktop/Github.png'

function Github(){
    this.Icon = Icon;
}

export default Github;